/* eslint-disable react/no-danger */
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Text } from '../../ui-components';
import { sanitizeHtml } from '../content-asset/sanitize-html';
import type { CommonStyles } from '../../ui-components/types';

export interface Props extends CommonStyles {
    id?: string;
    children: string;
    maxCharToTruncate?: number;
}

export const TextReadMore = ({
    id,
    children,
    maxCharToTruncate = 370,
    margin,
}: Props): React.ReactElement => {
    const [openReadMore, setOpenReadMore] = useState(false);

    const text = sanitizeHtml(children);
    const description = text.slice(0, maxCharToTruncate);
    const readMoreDescription = text.slice(maxCharToTruncate);

    return (
        <Text margin={margin} color="slt-pepper.1000">
            {openReadMore ? (
                <>
                    <span data-testid={id} dangerouslySetInnerHTML={{ __html: text }} />{' '}
                    {readMoreDescription ? (
                        <Button
                            id={`${id}-read-less`}
                            variant="text-button"
                            color="slt-primary-green.1000"
                            textSize="base"
                            onClick={(): void => setOpenReadMore(false)}
                        >
                            <FormattedMessage id="read.less" defaultMessage="Read less" />
                        </Button>
                    ) : null}
                </>
            ) : (
                <>
                    <span data-testid={id} dangerouslySetInnerHTML={{ __html: description }} />
                    {readMoreDescription ? (
                        <>
                            ...{' '}
                            <Button
                                id={`${id}-read-more`}
                                variant="text-button"
                                color="slt-primary-green.1000"
                                textSize="base"
                                onClick={(): void => setOpenReadMore(true)}
                            >
                                <FormattedMessage id="read.more" defaultMessage="Read more" />
                            </Button>
                        </>
                    ) : null}
                </>
            )}
        </Text>
    );
};

TextReadMore.defaultProps = {
    id: undefined,
    maxCharToTruncate: 370,
};
